<template>
  <BannerBlock titleClass="">
    <template v-slot:title>{{$t("banner.toAdvanceDesc")}}</template>
    <template v-slot:message>
      {{$t("banner.toAdvance")}}
    </template>
    <template v-slot:actions>
      <button class="btn btn-g-primary" @click="$router.push({ name: 'Pricing' })">{{$t("generals.upgrade")}} {{$t("generals.now")}}</button>
    </template>
    <template v-slot:default>
      <!-- <img class="ml-auto" src="@/core/assets/Dashboard/Banner/Upgrade/professional.svg" /> -->
      <!-- <div class="bg"></div> -->
      <div class="banner-image col-sm-5 d-none d-sm-flex">
        <img class="banner-img" :src="publicPath + require('@/core/assets/Dashboard/Banner/Upgrade/professional.svg')" />
      </div>
    </template>
  </BannerBlock>
</template>

<script>
import BannerBlock from "../../BannerBlock";
export default {
  name: "ToAdvanced",
  components: {
    BannerBlock
  },
  data() {
    return {
      // dayLeft: 2
    };
  },
  computed: {
  }
};
</script>
<style lang="scss" scoped>
// .bg {
//   background-image: url(~@/core/assets/Dashboard/Banner/Upgrade/professional.svg);
//   width: 288px;
// }
</style>
